import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import NftMarketplaceViewLayer from "../../components/NFT/NftMarketplaceViewLayer";

const NftMarketplaceViewPage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="NFT Marketplace View" />

                    {/* NftMarketplaceLayer */}
                    <NftMarketplaceViewLayer />
               </MasterLayout>
          </>
     );
};

export default NftMarketplaceViewPage;
